import { get } from 'lodash'
import Papa from 'papaparse'
import type { CustomField } from './types'

/**
 * Converts an array of result rows to a CSV string using Papa Parse,
 * mapping only the selected fields and using their labels as column headers.
 * Nested field paths (e.g. "contract.name") are resolved via lodash get.
 */
const buildCsvData = (results: any[], fields: CustomField[]): Array<Record<string, any>> =>
  results.map(row =>
    Object.fromEntries(fields.map(field => {
      const value = get(row, field.name)
      return [field.label, (field.exportFormat != null) ? field.exportFormat(field.name, value) : (value ?? '')]
    }))
  )

/**
 * Exports the given result rows to a CSV file download.
 * Only the provided fields are included, using field labels as column headers.
 */
export const exportToCsv = (results: any[], fields: CustomField[], filename = 'report.csv'): void => {
  const csv = Papa.unparse(buildCsvData(results, fields))
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
